import { render } from "./Documentation.vue?vue&type=template&id=6c2c4db3&scoped=true"
import script from "./Documentation.vue?vue&type=script&lang=js"
export * from "./Documentation.vue?vue&type=script&lang=js"

import "./Documentation.vue?vue&type=style&index=0&id=6c2c4db3&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2c4db3"]])

export default __exports__